import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export function AppHero({
  eyebrow,
  title,
  description,
  icon: Icon,
  children,
  className = "",
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  icon?: LucideIcon;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <section className={`app-hero ${className}`.trim()}>
      {Icon && (
        <div className="app-hero-orb" aria-hidden="true">
          <Icon size={22} />
        </div>
      )}
      <div className="app-hero-copy">
        {eyebrow && <span>{eyebrow}</span>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        {children}
      </div>
    </section>
  );
}
